module.exports = __webpack_public_path__ + "b7004eccd73bdfacc5c4df8272540030.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/comparisons_portrait.jpg
// module id = 585
// module chunks = 0